import { render, staticRenderFns } from "./ShippingAccounts.vue?vue&type=template&id=b2e90414&"
import script from "./ShippingAccounts.vue?vue&type=script&lang=js&"
export * from "./ShippingAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports